import { axiosGet, axiosPost } from '../../../../services/axiosService';

const baseInvestorIntegrationURL = 'investors';

const buildQueryString = (params = {}) => {
	const query = Object.entries(params)
		.filter(([, value]) => value !== undefined && value !== null && value !== '' && value !== 'all')
		.map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
		.join('&');
	return query ? `&${query}` : '';
};

export class InvestorDashboardService {
	getBorrowers(currentPage = 1, perPage = 10, filters = {}) {
		return axiosGet(
			null,
			baseInvestorIntegrationURL +
				`/borrowers?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}${buildQueryString(filters)}`
		);
	}

	getLoans(currentPage = 1, perPage = 10, filters = {}) {
		return axiosGet(
			null,
			baseInvestorIntegrationURL +
				`/loans?Paging.CurrentPage=${currentPage}&Paging.PerPage=${perPage}${buildQueryString(filters)}`
		);
	}

	getSummary() {
		return axiosGet(null, baseInvestorIntegrationURL + '/summary');
	}

	getDisbursePreview(loanId) {
		return axiosGet(null, baseInvestorIntegrationURL + `/loans/${loanId}/disburse-preview`, null, '', {
			hide_toaster: true,
		});
	}

	getLoanAgreement(loanId) {
		return axiosGet(null, baseInvestorIntegrationURL + `/loans/${loanId}/agreement`, null, '', {
			hide_toaster: true,
		});
	}

	disburseLoan(loanId) {
		return axiosPost(null, baseInvestorIntegrationURL + `/loans/${loanId}/disburse`, {
			hide_toaster: true,
		});
	}
}
